// @flow
import React from 'react';
import { Modal } from 'antd';
import { SpH5, SpButton } from 'components/DesignKit';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
  selectedLineItem: Array,
};

const UpdateSelectedItem = (props: Props) => {
  const {
    visible,
    close,
    submit,
    selectedLineItem,
  } = props;

  const updateItem = () => {
    submit(selectedLineItem);
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
        <SpButton onClick={updateItem} type="primary">Update</SpButton>,
      ]}
      title="Update Item Status"
    >
      <div className="px-4">
        <SpH5 className="pb-3">
          <div>Are you sure you want to update the item status?</div>
        </SpH5>
      </div>
    </Modal>
  );
};

// $FlowFixMe
export default UpdateSelectedItem;
